<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { CalculationMode } from '@fire-calc/domain-ts';
import { ModeSegmentedControl, AgeInput, MoneyInput } from '@fire-calc/ui-vue';
import { useCalculatorStore } from '../state/calculatorStore';

const store = useCalculatorStore();
const { scenario, mode, monthlyExpensesError, currentAgeError, retirementAgeError, monthlyContributionError } = storeToRefs(store);

const options = computed(() => [
  { value: CalculationMode.byRetirementAge, label: 'Dle věku', icon: 'track-target' },
  { value: CalculationMode.byMonthlyContribution, label: 'Dle úspor', icon: 'trending-up' },
] as Array<{ value: CalculationMode; label: string; icon: 'track-target' | 'trending-up' }>);
</script>

<template>
  <div class="flex flex-col gap-lg w-full">
    <ModeSegmentedControl
      :model-value="mode"
      :options="options"
      @update:model-value="(v: CalculationMode) => store.setMode(v)"
    />
    <div class="grid grid-cols-1 md:grid-cols-2 gap-lg w-full">
      <AgeInput
        :model-value="scenario.currentAge.value === 0 ? null : scenario.currentAge.value"
        :label="$t('labelCurrentAge')"
        :placeholder="$t('placeholderAge')"
        :error-text="currentAgeError"
        :required="true"
        @update:model-value="store.updateCurrentAge"
      />
      <MoneyInput
        :model-value="scenario.monthlyExpenses.value"
        :label="$t('labelMonthlyExpenses')"
        :placeholder="$t('placeholderExpenses')"
        :error-text="monthlyExpensesError"
        :required="true"
        @update:model-value="(v: number) => store.updateMonthlyExpenses(Math.round(v))"
      />
      <AgeInput
        v-if="mode === CalculationMode.byRetirementAge"
        :model-value="scenario.retirementAge.value === 0 ? null : scenario.retirementAge.value"
        :label="$t('labelRetirementAge')"
        :placeholder="$t('placeholderAge')"
        :error-text="retirementAgeError"
        :required="true"
        @update:model-value="store.updateRetirementAge"
      />
      <MoneyInput
        v-else
        :model-value="scenario.monthlyContribution.value"
        :label="$t('labelMonthlyContribution')"
        :placeholder="$t('placeholderMonthlyContribution')"
        :error-text="monthlyContributionError"
        :required="true"
        @update:model-value="(v: number) => store.updateMonthlyContribution(Math.round(v))"
      />
      <MoneyInput
        :model-value="scenario.currentPortfolio.value"
        :label="$t('labelCurrentPortfolio')"
        :placeholder="$t('placeholderPortfolio')"
        @update:model-value="(v: number) => store.updateCurrentPortfolio(Math.round(v))"
      />
    </div>
  </div>
</template>